import { useEffect, useRef } from "react";
import * as pc from "playcanvas";
import { objectShapes } from "3d/constants/common";
import { useAppSelector, selectors } from "store";
export var useCameraViews = function (app, camera, setPickerDisabled) {
    var selectedId = useAppSelector(selectors.selectSelectedId);
    var cameraViewId = useAppSelector(selectors.selectCameraViewId);
    var objectShapeId = useAppSelector(selectors.selectObjectShape);
    var appliedCameraViewId = useRef();
    // Only a change of view moves the camera. A view on a node is aimed at the
    // node selected when entering it; selecting another node does not follow it.
    useEffect(function () {
        if (cameraViewId === appliedCameraViewId.current)
            return;
        var view = objectShapes[objectShapeId].cameraViews[cameraViewId];
        var position;
        if (view.useNodePosition) {
            var entity = selectedId && app.root.findByName(selectedId);
            if (!entity)
                return;
            position = entity.getPosition();
        }
        else {
            position = new pc.Vec3(view.x || 0, view.y || 0, view.z || 0);
        }
        camera.maxDistance = view.maxDistance;
        camera.minDistance = view.minDistance;
        camera.setNextView(view.rotx, view.roty, view.distance, position, 0.5);
        appliedCameraViewId.current = cameraViewId;
        camera.allowOrbitInteraction = !view.locked;
        setPickerDisabled(!view.locked);
    }, [app, cameraViewId, selectedId, objectShapeId, camera, setPickerDisabled]);
};
